var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 263,
    viewBox: "0 0 375 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3893_26530)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3893_26530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 263
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 263L375 263L375 0L2.29922e-05 -3.27835e-05L0 263Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3893_26530)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.953 279.959L123.029 145.618C111.118 134.099 98.2032 137.794 94.182 153.867L67.0294 262.407C56.1226 305.988 82.3091 331.314 125.512 318.961L261.953 279.959Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.3223 293.969L88.9621 109.218C93.8181 93.3777 84.6655 83.5489 68.513 87.2643L-40.5421 112.357C-84.3345 122.428 -95.0082 157.256 -64.3853 190.132L32.3181 293.969L32.3223 293.969Z",
    fill: "#F9C416"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3893_26530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 263,
    fill: "white",
    transform: "translate(375 263) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBottomLeft);
export default __webpack_public_path__ + "static/media/bgBottomLeft.57d453c13ad4843d82f96a0ea7564610.svg";
export { ForwardRef as ReactComponent };